import React from "react";
import { Outlet, Link, withRouter, useHistory } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import IncomBody from "../components/IncomBody";
function Income() {
  return (
    <div>
      <Header />
      <IncomBody />
      <Footer />
    </div>
  );
}
export default withRouter(Income);
